import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../api/api';

export const useDocumentOverview = ({ resource, dateFrom, dateTo, statuses }) => {
  const config = useConfig();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Stable primitive key for the statuses array (avoids a complex dep expression).
  const statusKey = Array.isArray(statuses) ? statuses.join(',') : '';

  useEffect(() => {
    if (!config) return;

    const parts = [];
    if (dateFrom) parts.push(`dateFrom=${encodeURIComponent(dateFrom)}`);
    if (dateTo) parts.push(`dateTo=${encodeURIComponent(dateTo)}`);
    if (statusKey) {
      statusKey.split(',').forEach((s) => parts.push(`statuses[]=${s}`));
    }
    const query = parts.length ? `?${parts.join('&')}` : '';

    setIsLoading(true);
    DBRequest({
      config,
      path: `${resource}/overview${query}`,
      method: API_GET,
      onResponse: (res) => {
        setData(res.data);
        setError(null);
      },
      onError: (err) => setError(err),
      onLoading: setIsLoading,
    });
  }, [config, resource, dateFrom, dateTo, statusKey]);

  return { data, isLoading, error };
};
